// @flow

import * as React from 'react';
import type { Node } from 'react';
import { useEffect } from 'react';
import Button from 'components/Button';

import Basic from 'layouts/Basic';
import Title from 'components/Title';

import './style.scss';

import { ReactComponent as ReadMan } from 'assets/svg/directions-colour.svg';

import greatReads from 'content/greatReads';

export default function GreatReads(): Node {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production')
      window.analytics.page('Great reads');
  }, []);

  return (
    <Basic
      title="Great reads about open source software"
      subtitle="Read articles and follow people to dive deeper into the open-source movement"
      ilustration={<ReadMan />}
    >
      <div className="GreatReads">
        <div>
          <Title tag="h2" fontSize="m">
            <>
              <span role="img" aria-label="Books">
                📚
              </span>
              Articles
            </>
          </Title>
          <ul className="GreatReads__list ul-clear">
            {greatReads.articles.map(({ id, name, url, author }) => (
              <li key={id} className="GreatReads__element">
                <Button isText isTargetBlank href={url}>
                  {name} by {author}
                </Button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <Title tag="h2" fontSize="m">
            <>
              <span role="img" aria-label="bird">
                🐦
              </span>
              Twitter accounts
            </>
          </Title>
          <ul className="GreatReads__list ul-clear">
            {greatReads.twitterAccounts.map(({ id, handle, name, url }) => (
              <li key={id} className="GreatReads__element">
                <Button isText isTargetBlank href={url}>
                  {name} - @{handle}
                </Button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Basic>
  );
}
